export interface Location {
    id: string;
    name: string;
    imageKey: string;
    content: string;
    video?: string;
}

export type TabType = 'us-offices' | 'brokers';

export const usOfficesData: Location[] = [
    {
        id: 'los-angeles',
        name: 'Los Angeles',
        imageKey: 'losAngeles',
        content: 'Warehouse/yard capacity: 2000 cars',
        video: 'https://player.vimeo.com/video/1157477189?badge=0&autopause=0&player_id=0&app_id=58479',
    },
    {
        id: 'new-york',
        name: 'New York',
        imageKey: 'newYork',
        content: 'Warehouse/yard capacity: 1800 cars',
        video: 'https://player.vimeo.com/video/1157476984?badge=0&autopause=0&player_id=0&app_id=58479',
    },
    {
        id: 'savannah',
        name: 'Savannah',
        imageKey: 'savannah',
        content: 'Warehouse/yard capacity: 2000 cars',
        video: 'https://player.vimeo.com/video/1157477092?badge=0&autopause=0&player_id=0&app_id=58479',
    },
    {
        id: 'houston',
        name: 'Houston',
        imageKey: 'houston',
        content: 'Warehouse/yard capacity: 3000 cars',
        video: 'https://player.vimeo.com/video/1155897534?badge=0&autopause=0&player_id=0&app_id=58479',
    },
    {
        id: 'seattle',
        name: 'Seattle',
        imageKey: 'seattle',
        content: 'Warehouse/yard capacity: 2000 cars',
        video: 'https://player.vimeo.com/video/1155897737?badge=0&autopause=0&player_id=0&app_id=58479',
    },
    {
        id: 'norfolk',
        name: 'Norfolk',
        imageKey: 'norfolk',
        content: 'Warehouse/yard capacity: 1000 cars',
    },
];
